import React from "react";
import { Button } from "semantic-ui-react";

export default class OptionButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
        };
    }

    setHover = () => this.setState({ hovered: true });
    removeHover = () => this.setState({ hovered: false });

    render() {
        let componentStyles = {
            default: {
                width: "100%",
                fontSize: "1.25em",
                marginBottom: "5px",
                background: this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
            grid: {
                width: "48%",
                height: "6em",
                display: "inline-block",
                verticalAlign: "middle",
                fontSize: "1.25em",
                marginBottom: "5px",
                background: this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
        };
        return (
            <Button
                style={componentStyles[this.props.layout]}
                onMouseEnter={this.setHover}
                onMouseLeave={this.removeHover}
                onClick={() => this.props.handleClick(this.props.index)}
            >
                {this.props.name}
            </Button>
        );
    }
}
